import { Component, Input } from '@angular/core';
import { DataType } from 'src/app/core/models/document/custom-field-base-model';
import { CustomFieldGroupModel } from 'src/app/core/models/myfile/custom-field-group.model';
import { GlobalComponent } from 'src/app/global-component';

@Component({
  selector: 'app-accordian-custom-field-displayer',
  templateUrl: './accordian-custom-field-displayer.component.html',
  styleUrls: ['./accordian-custom-field-displayer.component.scss']
})
export class AccordionCustomFieldDisplayerComponent {

  datePattern = GlobalComponent.datePattern;
  activeIdIndex: number = 0
  basicEdited: boolean | undefined = undefined;
  @Input() disableEditing: boolean = false;
  @Input() customFieldsGroups: CustomFieldGroupModel[] = [];

  DataTypeEnum = DataType;

  updateActiveIDIndex(groupIndex: number) {
    this.activeIdIndex = groupIndex;
  }

  getCheckboxBoolValue(value: string | undefined): boolean {
    if (value) {
      if (value == "☑") {
        return true;
      } else {
        return false;
      }
    } else {
      return false
    }
  }

  setCheckboxBoolValue(value: string | undefined, groupIndex: number, subGroupIndex: number, myfileIndex: number) {
    if (this.customFieldsGroups[groupIndex] && this.customFieldsGroups[groupIndex].subgroups[subGroupIndex] && this.customFieldsGroups[groupIndex].subgroups[subGroupIndex].group[myfileIndex]) {
      if (value) {
        if (value == `☐`) {
          this.customFieldsGroups[groupIndex].subgroups[subGroupIndex].group[myfileIndex].value = `☑`

        } else {
          this.customFieldsGroups[groupIndex].subgroups[subGroupIndex].group[myfileIndex].value = `☐`
        }
      } else {
        this.customFieldsGroups[groupIndex].subgroups[subGroupIndex].group[myfileIndex].value = `☐`
      }
    }
  }


}
